import { QFlex } from '@qualio/ui-components';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import { MutableRefObject, useMemo, useRef, useState } from 'react';
import { Document } from 'react-pdf';
import { PDFJS_DOCUMENT_OPTIONS } from '../../../../../config/PdfJsConfig';
import { QualioAttachmentPreview } from '../../hooks/useAttachmentPreview';
import { useElementDimensions } from '../../hooks/useElementDimensions';
import { PDFPageV2 } from './PDFPageV2';
import { XlsxPage } from './XlsxPage';

export const PDFDocumentViewerV2 = ({
  attachmentPreview,
  isPaginated,
  pageNumber,
  zoom,
  isXlsx,
  onLoadSuccess,
}: {
  attachmentPreview: QualioAttachmentPreview;
  isPaginated: boolean;
  pageNumber: number;
  zoom: number;
  isXlsx: boolean;
  onLoadSuccess?: (pageCount: number) => void;
}) => {
  const [pageCount, setPageCount] = useState<number>(0);
  const [pdfDocument, setPdfDocument] = useState<PDFDocumentProxy>();

  const wrapper = useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;
  const { width: containerWidth, height: containerHeight } =
    useElementDimensions(wrapper);

  const handleLoadSuccess = (pdf: PDFDocumentProxy) => {
    setPageCount(pdf.numPages);
    setPdfDocument(pdf);
    onLoadSuccess?.(pdf.numPages);
  };

  const document = useMemo(
    () => ({
      url: attachmentPreview.url,
      withCredentials: true,
    }),
    [attachmentPreview.url],
  );

  return (
    <QFlex
      width="100%"
      ref={wrapper}
      direction="column"
      alignItems={isXlsx ? 'flex-start' : 'center'}
    >
      <Document
        file={document}
        options={PDFJS_DOCUMENT_OPTIONS}
        onLoadSuccess={handleLoadSuccess}
      >
        {isXlsx ? (
          <XlsxPage
            zoom={zoom}
            pageNumber={pageNumber}
            containerWidth={containerWidth}
            containerHeight={containerHeight}
          />
        ) : (
          <PDFPageV2
            zoom={zoom}
            pageCount={pageCount}
            pageNumber={pageNumber}
            isPaginated={isPaginated}
            pdfDocument={pdfDocument}
          />
        )}
      </Document>
    </QFlex>
  );
};
